import { CONFIG } from '~src/config/config';

export enum AppRoute {
  SITE = 's',
  ADDRESS_BOOK = 'address-book',
  CARRIER_CONTRACTS = 'carrier-contracts',
  CREATE = 'create',
  PENDING = 'pending',
  DUPLICATE = 'duplicate',
  EDIT = 'edit',
  EXPIRED = '/expired',
  LOGIN = '/login',
  LOGIN_CALLBACK = '/login/callback',
  LOGGED_OUT = '/logged-out',
  ROOT = '/',
  RETURN = 'return',
  SETTINGS = 'settings',
  SHIPMENTS = 'shipments',
  SHIPMENTS_CREATE = 'shipments/create',
  TRANSPORT_ORDERS = 'orders',
  SHIPMENT_TEMPLATES = 'shipment-templates',
  BOOKING_RULES = 'booking-rules',
  BOOKING_RULE_CONFIGURATOR = 'booking-rule-configurator',
  DASHBOARD = 'dashboard',
  PENDING_SHIPMENTS = 'pending-shipments',
}

export enum ExternalRoute {
  HELP_CENTER = 'https://support.ingrid.com',
  REPORT_ISSUE = 'https://ingrid-ab.atlassian.net/servicedesk/customer/portals',
}

export const IMPRoute = {
  CHECKOUT_APP: CONFIG.IMP_CHECKOUT_APP_URL,
  INSTORE_APP: CONFIG.IMP_INSTORE_APP_URL,
  SETTINGS_APP: CONFIG.IMP_SETTINGS_APP_URL,
  TRACKING_APP: CONFIG.IMP_TRACKING_APP_URL,
};
